import React, { useEffect, useState, useContext } from 'react';
import { UserContext } from '../../contexts/userContext';
import MachineSelect from '../report/MachineSelect';
import request from '../../../services/Request';
import LoadingIcon from '../../items/buttons/LoadingIcon';
import BackButton from '../../items/buttons/BackButton';
import { userLimits } from '../uitls/userLimits';
import ModernTable, { ModernPageContainer, ModernPageHeader } from '../components/ModernTable';
import { localDateRange } from '../../../services/method/methods';
import moment from 'moment';
import { Grid, Container, Box, Typography, Chip, alpha } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import EmailIcon from '@mui/icons-material/Email';
const getGroupsURL = `/groupsAndMachinesForReport/`;
const getAlerts = `/logs/getEvent`;

export default function AlertEmail(props) {
  const theme = useTheme();
  var date = new Date();
  const [machines, setMachines] = useState([]);
  const [groups, setGroups] = useState([]);
  const [groupV, setgroupV] = useState([]);
  const [radio, setRadio] = useState('a');
  const [loading, setLoading] = useState(true);

  const [data, setData] = useState([]);
  const [startDate, setStartDate] = useState(new Date(date.getFullYear(), date.getMonth(), 1));
  const [endDate, setEndDate] = useState(new Date());

  const [pagination, setPagination] = useState(
    localStorage.getItem('table_view_alertEmail')
      ? localStorage.getItem('table_view_alertEmail')
      : 20
  );

  useEffect(() => {
    localStorage.setItem('table_view_alertEmail', pagination);
  }, [pagination]);

  const [machinesName, setmachinesName] = useState('All Machines');

  const { userEmail, setFiltered, filterd } = useContext(UserContext);
  const { id, tableTitle, superAdmin } = userLimits(
    props.match.params.id,
    props.match.params.group,
    'Email Alerts',
    'view_report'
  );

  const columns = [
    {
      title: 'Time',
      field: 'dateTime',
      render: (rowData) => (
        <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '0.875rem' }}>
          {moment.utc(new Date(rowData.dateTime)).format('lll')}
        </Typography>
      ),
    },
    {
      title: 'Machine',
      field: 'machineId',
      render: (rowData) => (
        <Chip
          label={rowData.machineId}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.info.main, 0.12),
            color: theme.palette.info.dark,
            border: `1.5px solid ${alpha(theme.palette.info.main, 0.3)}`,
          }}
        />
      ),
    },
    {
      title: 'Description',
      field: 'customID.text',
      render: (rowData) => {
        let text = rowData.customID?.text;
        if (rowData?.motor?.length > 2) {
          text = text?.replace('[[[STOCK]]]', rowData?.motor[0]);
          text = text?.replace('[[[FLOOR]]]', rowData?.motor[1]);
          text = text?.replace('[[[LANE]]]', rowData?.motor[2]);
        }
        text = text?.replace('[[[VAL]]]', rowData?.val);
        return (
          <Typography
            variant="body2"
            sx={{
              fontWeight: 500,
              color: rowData.customID?.color || theme.palette.text.primary,
            }}
          >
            {text}
          </Typography>
        );
      },
    },
    {
      title: 'Code',
      render: (rowData) => {
        const code = rowData.code1 && rowData.code2 ? rowData.code1 + '/' + rowData.code2 : '';
        return code ? (
          <Typography variant="body2" sx={{ fontFamily: 'monospace', fontWeight: 600 }}>
            {code}
          </Typography>
        ) : (
          <Typography variant="body2" color="text.secondary">
            -
          </Typography>
        );
      },
    },
    {
      title: 'Motor',
      field: 'motor',
      render: (rowData) => (
        <Typography variant="body2" sx={{ fontFamily: 'monospace' }}>
          {rowData.motor || '-'}
        </Typography>
      ),
    },
    {
      title: 'Info',
      render: (rowData) => (
        <Typography variant="body2" color="text.secondary">
          {rowData.description1 || '-'}
        </Typography>
      ),
    },
  ];

  useEffect(() => {
    let isCancelled = false;

    async function getGroups() {
      await request({
        method: 'get',
        url: !props.match.params.group && superAdmin ? getGroupsURL : getGroupsURL + userEmail,
      })
        .then((res) => {
          res.data.machines.forEach((element) => {
            element.product?.forEach((e) => {
              e.id.name = e.id.name.en;
            });
          });
          if (!isCancelled) {
            setGroups(res.data.groups);
            setMachines(res.data.machines);
            setFiltered(res.data.machines);
          }
        })
        .finally(() => {
          setLoading(true);
        });
    }
    getGroups();

    return () => {
      setMachines([]);
      setGroups([]);

      isCancelled = true;
    };
  }, []);

  const handleStartDate = (e) => {
    setStartDate(e);
  };

  const handleEndDate = (e) => {
    setEndDate(e);
  };

  const handleChange = async (event) => {
    let filteredArray = [];
    setLoading(false);
    let myIDs = 0;
    if (radio == 'a') {
      setFiltered(machines);
      myIDs = machines.map((e) => e._id).join(',');
      setmachinesName('All Machines');
      filteredArray = [...machines];
    }
    if (radio == 'g') {
      const myArray = groupV.map((e) => e.machineID);
      var merged = [].concat.apply([], myArray);
      merged = merged.filter((e, i, self) => i === self.findIndex((t) => t._id == e._id));
      // const filteredArray = machines.filter((e, i) => i == merged.findIndex((t)=>(t._id == e._id)));
      machines.forEach((e) => {
        merged.findIndex((t) => {
          if (t._id == e._id) {
            filteredArray.push(e);
          }
        });
      });
      setFiltered(filteredArray);
      myIDs = filteredArray.map((e) => e._id).join(',');
      setmachinesName(`Groups: ${groupV.map((e) => e.name).join(', ')} `);
    }
    if (radio == 'm') {
      setFiltered(groupV);
      filteredArray = [...groupV];
      myIDs = groupV.map((e) => e._id).join(',');
      setmachinesName(`Machines: ${groupV.map((e) => e.name).join(', ')} `);
    }

    const { startDateString, endDateString } = localDateRange(startDate, endDate);

    await request({
      method: 'post',
      url: getAlerts,
      data: {
        machineID: myIDs,
        id: id,
        startDate: startDateString,
        endDate: endDateString,
      },
    }).then((res) => {
      let filterAlert = res.data;
      console.log('res.data', res.data);
      if (id === 'adrian.pittaway@msccruises.com') {
        filterAlert = res.data.filter((e) => e?.customID?.code !== '1171500');
      }
      setData(filterAlert);
      setLoading(true);
    });
  };

  return (
    <ModernPageContainer>
      {!loading && <LoadingIcon />}

      <ModernPageHeader
        title={tableTitle || 'Email Alerts'}
        subtitle="View email alerts and notifications from machines"
        icon={EmailIcon}
      />

      <Container maxWidth="xl" sx={{ mt: 3, px: 0 }}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <MachineSelect
              filterd={filterd}
              handleStartDate={handleStartDate}
              handleEndDate={handleEndDate}
              startDate={startDate}
              endDate={endDate}
              setRadio={setRadio}
              setgroupV={setgroupV}
              radio={radio}
              groupV={groupV}
              groups={groups}
              machines={machines}
              handleChange={handleChange}
            />
          </Grid>
        </Grid>
      </Container>

      <Box sx={{ mt: 3 }}>
        <ModernTable
          onRowsPerPageChange={setPagination}
          columns={columns}
          data={data}
          options={{
            pageSize: parseInt(pagination),
            pageSizeOptions: [10, 20, 50, 100, 200],
            actionsColumnIndex: -1,
          }}
        />
      </Box>

      <Box sx={{ mt: 8, display: 'flex', justifyContent: 'center' }}>
        <BackButton marginRight={0} />
      </Box>
    </ModernPageContainer>
  );
}
